import HelpDocumentPic from './../assets/HelpDocument.png';
import HelpPermissionPic from './../assets/HelpPermission.png';
import HelpProjectPic from './../assets/HelpProject.png';

interface HelpTopic {
  labelKey: string;
  featureKey: string;
  to: string;
  imageSrc: string;
}

export const HELP_TOPICS: HelpTopic[] = [
  {
    labelKey: 'help.topics.projects.label',
    featureKey: 'help.topics.projects.feature',
    to: '/helps/projects',
    imageSrc: HelpProjectPic
  },
  {
    labelKey: 'help.topics.documents.label',
    featureKey: 'help.topics.documents.feature',
    to: '/helps/documents',
    imageSrc: HelpDocumentPic
  },
  {
    labelKey: 'help.topics.permissions.label',
    featureKey: 'help.topics.permissions.feature',
    to: '/helps/permissions',
    imageSrc: HelpPermissionPic
  }
];
